var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.292,
    height: 17.266,
    viewBox: "0 0 20.292 17.266",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subject",
    transform: "translate(-0.325 -1.867)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(440.415 66.323)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M-420.721-47.19h-18.452a.918.918,0,0,1-.917-.917V-63.539a.918.918,0,0,1,.917-.917h18.457a.911.911,0,0,1,.781.436.911.911,0,0,1,.038.894l-3.753,7.45,3.742,7.144a.911.911,0,0,1-.028.9A.91.91,0,0,1-420.721-47.19Zm-17.869-1.5h16.906l-3.434-6.556a.918.918,0,0,1-.006-.839l3.462-6.872H-438.59Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_1",
    "data-name": "Line 1",
    d: "M10.184.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H10.184a.75.75,0,0,1,.75.75A.75.75,0,0,1,10.184.75Z",
    transform: "translate(-436.027 -59.964)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_2",
    "data-name": "Line 2",
    d: "M10.184.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H10.184a.75.75,0,0,1,.75.75A.75.75,0,0,1,10.184.75Z",
    transform: "translate(-436.027 -51.682)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_3",
    "data-name": "Line 3",
    d: "M5.705.75H0A.75.75,0,0,1-.75,0,.75.75,0,0,1,0-.75H5.705a.75.75,0,0,1,.75.75A.75.75,0,0,1,5.705.75Z",
    transform: "translate(-436.027 -55.669)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubject);
export default __webpack_public_path__ + "static/media/subject.91c6e5c528fe8d067770c694d46f0fb8.svg";
export { ForwardRef as ReactComponent };